export default __webpack_public_path__ + "static/media/corporate-icon.0408d449.svg";